<div [formGroup]="answerForm">
  <input
    type="text"
    formControlName="answer"
    placeholder="Indtast svarmulighed"
  />
</div>
